import { BaseError, createErrorBuilder, } from '@wix/public-editor-platform-errors';
export var ComponentsNamespaceErrorCode;
(function (ComponentsNamespaceErrorCode) {
    ComponentsNamespaceErrorCode["UnknownComponentSetProp"] = "UnknownComponentSetProps";
    ComponentsNamespaceErrorCode["UnknownComponentGetProp"] = "UnknownComponentGetProps";
    ComponentsNamespaceErrorCode["UnknownSetProp"] = "UnknownSetProp";
})(ComponentsNamespaceErrorCode || (ComponentsNamespaceErrorCode = {}));
class ComponentsNamespaceError extends BaseError {
    constructor(message, code) {
        super(message, code, 'EP ComponentsNamespace Error');
    }
}
export const createComponentsNamespaceError = createErrorBuilder(ComponentsNamespaceError);
//# sourceMappingURL=errors.js.map